/**
 * Gotenberg-supported dimension units for PDF conversion.
 * Reference: https://gotenberg.dev/docs/routes#page-properties
 *
 * Gotenberg supports: 72pt, 96px, 1in, 25.4mm, 2.54cm, or 6pc.
 * Default unit is inches if unspecified.
 */
export const GOTENBERG_DIMENSION_UNITS = ['mm', 'cm', 'in', 'px', 'pt', 'pc'] as const

export type GotenbergDimensionUnit = (typeof GOTENBERG_DIMENSION_UNITS)[number]

/**
 * Regex pattern for matching dimension values with Gotenberg-supported units.
 * Supports both comma and period as decimal separators (e.g., "10.5mm" or "10,5mm").
 */
export const GOTENBERG_DIMENSION_PATTERN = `(${GOTENBERG_DIMENSION_UNITS.join('|')})`

/**
 * Conversion rates from various units to pixels (CSS standard).
 * - 1 inch = 96 pixels
 * - 1 cm = 37.795275591 pixels
 * - 1 mm = 3.7795275591 pixels
 * - 1 pt = 1.333333 pixels
 * - 1 pc = 16 pixels
 */
export const DIMENSION_TO_PIXEL_CONVERSION: Record<GotenbergDimensionUnit, number> = {
  mm: 3.7795275591,
  cm: 37.795275591,
  in: 96,
  px: 1,
  pt: 1.333333,
  pc: 16,
}
